import { useMutation } from '@tanstack/react-query';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

type RemoveAIPromptTemplateDto = {
  _id: string;
};

export const removeAIPromptTemplate = ({ _id }: RemoveAIPromptTemplateDto) => {
  return axios.delete(`/ai/prompt-templates/${_id}`);
};

type QueryFnType = typeof removeAIPromptTemplate;

type UseRemoveAIPromptTemplateOptions = {
  config?: MutationConfig<QueryFnType>;
};

export const useRemoveAIPromptTemplate = ({ config }: UseRemoveAIPromptTemplateOptions = {}) => {
  const { onSuccess, ...restConfig } = config || {};

  return useMutation({
    ...restConfig,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['ai-prompt-templates']);
      onSuccess?.(...args);
    },
    mutationFn: removeAIPromptTemplate,
  });
};
